import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../store/slices/authSlice';
import userProfileReducer from '../store/slices/userProfileSlice';
import mealsReducer from '../store/slices/mealsSlice';
import healthReducer from '../store/slices/healthSlice';
import assistantReducer from '../store/slices/assistantSlice';
import subscriptionReducer from '../store/slices/subscriptionSlice';
import addressReducer from '../store/slices/addressSlice';
import weeklyMenuReducer from '../store/slices/weeklyMenuSlice';
import orderReducer from '../store/slices/orderSlice';
import notificationReducer from '../store/slices/notificationSlice';
import walletReducer from '../store/slices/walletSlice';
import socialReducer from '../store/slices/socialSlice';
import gamificationReducer from '../store/slices/gamificationSlice';
import adminReducer from '../store/slices/adminSlice';
import bcaFormReducer from '../store/slices/bcaFormSlice';
import featureFlagsReducer from '../store/slices/featureFlagsSlice';
import { toastMiddleware } from './toastMiddleware';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    userProfile: userProfileReducer,
    meals: mealsReducer,
    health: healthReducer,
    assistant: assistantReducer,
    subscription: subscriptionReducer,
    address: addressReducer,
    weeklyMenu: weeklyMenuReducer,
    orders: orderReducer,
    notifications: notificationReducer,
    wallet: walletReducer,
    social: socialReducer,
    gamification: gamificationReducer,
    admin: adminReducer,
    bcaForm: bcaFormReducer,
    featureFlags: featureFlagsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(toastMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
